import { ACCOUNTING_SETTING_ACTION_TYPE } from '../actions';

const initialState = {};

const accountingSettingsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACCOUNTING_SETTING_ACTION_TYPE.GET_SETTINGS:
    case ACCOUNTING_SETTING_ACTION_TYPE.EDIT_SETTING:
      return payload || state;

    default:
      return state;
  }
};

export default accountingSettingsReducer;
